<template>
    <div class="container-fluid">
        <b-form @submit="onSubmit" novalidate="novalidate">
            <b-card>
                <b-tabs>
                    <b-tab title="Integração Disal" active>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-header-icon card-header-rose">
                                        <div class="card-icon">
                                            <i class="material-icons">receipt</i>
                                        </div>
                                        <h4 class="card-title ">Vendas</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.disal.login != '', 'has-danger' : validation.disal.login != '' }">
                                                    <label class="bmd-label-floating">Login <span v-if="form.disal.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.disal.login" />
                                                    <label v-if="validation.disal.login != ''" id="disal-login-error" class="error">{{ validation.disal.login }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.disal.password != '', 'has-danger' : validation.disal.password != '' }">
                                                    <label class="bmd-label-floating">Senha <span v-if="form.disal.is_active == 1">*</span></label>
                                                    <input type="password" class="form-control" v-model="form.disal.password" />
                                                    <label v-if="validation.disal.password != ''" id="disal-password-error" class="error">{{ validation.disal.password }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.disal.code_store != '', 'has-danger' : validation.disal.code_store != '' }">
                                                    <label class="bmd-label-floating">Código da Loja <span v-if="form.disal.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.disal.code_store" />
                                                    <label v-if="validation.disal.code_store != ''" id="disal-code_store-error" class="error">{{ validation.disal.code_store }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.disal.retroactive_months != '', 'has-danger' : validation.disal.retroactive_months != '' }">
                                                    <label class="bmd-label-floating">Quantidade de meses retroativos <span v-if="form.disal.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.disal.retroactive_months" />
                                                    <label v-if="validation.disal.retroactive_months != ''" id="disal-retroactive_months-error" class="error">{{ validation.disal.retroactive_months }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Ativo?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.disal.is_active" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Logar telas?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.disal.is_logging" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group bmd-form-group is-filled"
                                     v-bind:class="{'has-danger' : validation.disal.administrator_id != '' }">
                                    <label class="bmd-label-floating">Administradora <span v-if="form.disal.is_active == 1">*</span></label>
                                    <model-list-select 
                                        class="form-control"
                                        :list="administrators"     
                                        option-value="id"
                                        option-text="name"
                                        v-model="form.disal.administrator_id">
                                    </model-list-select>
                                    <label v-if="validation.disal.administrator_id != ''" id="disal-administrator_id-error" class="error">{{ validation.disal.administrator_id }}</label>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Integração GMAC">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-header-icon card-header-rose">
                                        <div class="card-icon">
                                            <i class="material-icons">receipt</i>
                                        </div>
                                        <h4 class="card-title ">Vendas</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon.login != '', 'has-danger' : validation.newcon.login != '' }">
                                                    <label class="bmd-label-floating">Login <span v-if="form.newcon.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.newcon.login" />
                                                    <label v-if="validation.newcon.login != ''" id="newcon-login-error" class="error">{{ validation.newcon.login }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon.password != '', 'has-danger' : validation.newcon.password != '' }">
                                                    <label class="bmd-label-floating">Senha <span v-if="form.newcon.is_active == 1">*</span></label>
                                                    <input type="password" class="form-control" v-model="form.newcon.password" />
                                                    <label v-if="validation.newcon.password != ''" id="newcon-password-error" class="error">{{ validation.newcon.password }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon.code_store != '', 'has-danger' : validation.newcon.code_store != '' }">
                                                    <label class="bmd-label-floating">Código da Loja <span v-if="form.newcon.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.newcon.code_store" />
                                                    <label v-if="validation.newcon.code_store != ''" id="newcon-code_store-error" class="error">{{ validation.newcon.code_store }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon.retroactive_months != '', 'has-danger' : validation.newcon.retroactive_months != '' }">
                                                    <label class="bmd-label-floating">Quantidade de meses retroativos <span v-if="form.newcon.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.newcon.retroactive_months" />
                                                    <label v-if="validation.newcon.retroactive_months != ''" id="newcon-retroactive_months-error" class="error">{{ validation.newcon.retroactive_months }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Dados do e-mail</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon.login_mail != '', 'has-danger' : validation.newcon.login_mail != '' }">
                                                    <label class="bmd-label-floating">Login do e-mail <span v-if="form.newcon.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.newcon.login_mail" />
                                                    <label v-if="validation.newcon.login_mail != ''" id="newcon-login_mail-error" class="error">{{ validation.newcon.login_mail }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon.password_mail != '', 'has-danger' : validation.newcon.password_mail != '' }">
                                                    <label class="bmd-label-floating">Senha do e-mail<span v-if="form.newcon.is_active == 1">*</span></label>
                                                    <input type="password" class="form-control" v-model="form.newcon.password_mail" />
                                                    <label v-if="validation.newcon.password_mail != ''" id="newcon-password_mail-error" class="error">{{ validation.newcon.password_mail }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Pagar parcelas automaticamente?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon.auto_pay_installments" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Tipo de parcela</h4>
                                                    <model-list-select 
                                                        class="form-control"
                                                        :list="installmentsTypes"     
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.newcon.installment_type">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Parcela faturada</h4>
                                                    <input type="text" class="form-control" v-model="form.newcon.installment_faturada" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Ativo?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon.is_active" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Logar telas?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon.is_logging" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Atualizar Carta de Crédito?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon.update_value" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group bmd-form-group is-filled"
                                     v-bind:class="{'has-danger' : validation.newcon.administrator_id != '' }">
                                    <label class="bmd-label-floating">Administradora <span v-if="form.newcon.is_active == 1">*</span></label>
                                    <model-list-select 
                                        class="form-control"
                                        :list="administrators"     
                                        option-value="id"
                                        option-text="name"
                                        v-model="form.newcon.administrator_id">
                                    </model-list-select>
                                    <label v-if="validation.newcon.administrator_id != ''" id="newcon-administrator_id-error" class="error">{{ validation.newcon.administrator_id }}</label>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Integração NewCon/Unifisa">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-header-icon card-header-rose">
                                        <div class="card-icon">
                                            <i class="material-icons">receipt</i>
                                        </div>
                                        <h4 class="card-title ">Vendas</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon_unifisa.login != '', 'has-danger' : validation.newcon_unifisa.login != '' }">
                                                    <label class="bmd-label-floating">Login <span v-if="form.newcon_unifisa.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.newcon_unifisa.login" />
                                                    <label v-if="validation.newcon_unifisa.login != ''" id="newcon_unifisa-login-error" class="error">{{ validation.newcon_unifisa.login }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon_unifisa.password != '', 'has-danger' : validation.newcon_unifisa.password != '' }">
                                                    <label class="bmd-label-floating">Senha <span v-if="form.newcon_unifisa.is_active == 1">*</span></label>
                                                    <input type="password" class="form-control" v-model="form.newcon_unifisa.password" />
                                                    <label v-if="validation.newcon_unifisa.password != ''" id="newcon_unifisa-password-error" class="error">{{ validation.newcon_unifisa.password }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon_unifisa.code_store != '', 'has-danger' : validation.newcon_unifisa.code_store != '' }">
                                                    <label class="bmd-label-floating">Código da Loja <span v-if="form.newcon_unifisa.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.newcon_unifisa.code_store" />
                                                    <label v-if="validation.newcon_unifisa.code_store != ''" id="newcon_unifisa-code_store-error" class="error">{{ validation.newcon_unifisa.code_store }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.newcon_unifisa.retroactive_months != '', 'has-danger' : validation.newcon_unifisa.retroactive_months != '' }">
                                                    <label class="bmd-label-floating">Quantidade de meses retroativos <span v-if="form.newcon_unifisa.is_active == 1">*</span></label>
                                                    <input type="text" class="form-control" v-model="form.newcon_unifisa.retroactive_months" />
                                                    <label v-if="validation.newcon_unifisa.retroactive_months != ''" id="newcon_unifisa-retroactive_months-error" class="error">{{ validation.newcon_unifisa.retroactive_months }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Pagar parcelas automaticamente?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon_unifisa.auto_pay_installments" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Tipo de parcela</h4>
                                                    <model-list-select 
                                                        class="form-control"
                                                        :list="installmentsTypes"     
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.newcon_unifisa.installment_type">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Parcela faturada</h4>
                                                    <input type="text" class="form-control" v-model="form.newcon_unifisa.installment_faturada" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3 hide">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Tipo de parcela</h4>
                                                    <model-list-select 
                                                        class="form-control"
                                                        :list="installmentsTypes"     
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.newcon_unifisa.installment_type">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Coluna de Comissão</h4>
                                                    <model-list-select 
                                                        class="form-control"
                                                        :list="colsComissionado"     
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.newcon_unifisa.comissionado">
                                                    </model-list-select>
                                                    <label v-if="validation.newcon_unifisa.comissionado != ''" id="newcon_unifisa-comissionado-error" class="error">{{ validation.newcon_unifisa.comissionado }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Ativo?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon_unifisa.is_active" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Logar telas?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon_unifisa.is_logging" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3 hide">
                                                <div class="form-group bmd-form-group">
                                                    <h4 class="title">Atualizar Carta de Crédito?</h4>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.newcon_unifisa.update_value" value="1" />
                                                            <span class="toggle"></span>
                                                            Sim
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group bmd-form-group is-filled"
                                     v-bind:class="{'has-danger' : validation.newcon_unifisa.administrator_id != '' }">
                                    <label class="bmd-label-floating">Administradora <span v-if="form.newcon_unifisa.is_active == 1">*</span></label>
                                    <model-list-select 
                                        class="form-control"
                                        :list="administrators"     
                                        option-value="id"
                                        option-text="name"
                                        v-model="form.newcon_unifisa.administrator_id">
                                    </model-list-select>
                                    <label v-if="validation.newcon_unifisa.administrator_id != ''" id="newcon_unifisa-administrator_id-error" class="error">{{ validation.newcon_unifisa.administrator_id }}</label>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
                <div class="card-footer">
                    <form-buttons
                            v-bind:to-back="{name: 'dashboard'}"
                            text-back="Voltar"
                            icon-back="keyboard_arrow_left" />
                </div>
            </b-card>
        </b-form>
    </div>
</template>
<script>
    import validation from "@/services/validations.service";

    export default {
        data() {
            return {
                form: {
                    disal: {
                        administrator_id: '',
                        is_active: 0,
                        login: '',
                        password: '',
                        code_store: '',
                        retroactive_months: '12',
                        is_logging: 0,
                    },
                    newcon: {
                        administrator_id: '',
                        is_active: 0,
                        login: '',
                        password: '',
                        login_mail: '',
                        password_mail: '',
                        code_store: '',
                        retroactive_months: '12',
                        is_logging: 0,
                        installment_type: 'LIB',
                        update_value: false,
                        auto_pay_installments: false,
                        installment_faturada: 800
                    },
                    newcon_unifisa: {
                        administrator_id: '',
                        is_active: 0,
                        login: '',
                        password: '',
                        code_store: '',
                        retroactive_months: '12',
                        is_logging: 0,
                        installment_type: 'LIB',
                        update_value: false,
                        comissionado: '',
                        auto_pay_installments: false,
                        installment_faturada: 800
                    }
                },
                colsComissionado: [
                    {
                        id: "5",
                        name: "Comissionado"
                    },
                    {
                        id: "6",
                        name: "Usuário"
                    }
                ],
                installmentsTypes: [
                    {
                        id: 'PCL',
                        name: 'PCL'
                    },
                    {
                        id: 'LIB',
                        name: 'LIB'
                    }
                ],
                validation: {
                    disal: {
                        administrator_id: '',
                        is_active: '',
                        login: '',
                        password: '',
                        code_store: '',
                        retroactive_months: '',
                        is_logging: '',
                    },
                    newcon: {
                        administrator_id: '',
                        is_active: '',
                        login: '',
                        password: '',
                        login_mail: '',
                        password_mail: '',
                        code_store: '',
                        retroactive_months: '',
                        is_logging: '',
                    },
                    newcon_unifisa: {
                        administrator_id: '',
                        is_active: '',
                        login: '',
                        password: '',
                        code_store: '',
                        retroactive_months: '',
                        is_logging: '',
                        comissionado: '',
                    }
                }
            };
        },
        computed: {
            administrators: {
                set: function(_administrator) {

                },
                get: function() {
                    return this.$store.state.administrators.itens;
                }
            }
        },
        created: function() {
            this.getAdministrators();
        },
        methods: {
            async getAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getIntegrations();
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                });
            },
            async getIntegrations() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('integrations/all');

                response.then(function (_integrations) {
                    _integrations.map(function (_integration) {
                        if (_integration.key == "disal_is_active") {
                            self.form.disal.is_active = _integration.value == '1';
                        }
                        if (_integration.key == "disal_login") {
                            self.form.disal.login = _integration.value;
                        }
                        if (_integration.key == "disal_password") {
                            self.form.disal.password = _integration.value;
                        }
                        if (_integration.key == "disal_code_store") {
                            self.form.disal.code_store = _integration.value;
                        }
                        if (_integration.key == 'disal_administrator') {
                            self.form.disal.administrator_id = parseInt(_integration.value)
                        }
                        if (_integration.key == 'disal_retroactive_months') {
                            self.form.disal.retroactive_months = parseInt(_integration.value)
                        }
                        if (_integration.key == 'disal_is_logging') {
                            self.form.disal.is_logging = parseInt(_integration.value)
                        }
                        if (_integration.key == "newcon_is_active") {
                            self.form.newcon.is_active = _integration.value == '1';
                        }
                        if (_integration.key == "newcon_login") {
                            self.form.newcon.login = _integration.value;
                        }
                        if (_integration.key == "newcon_password") {
                            self.form.newcon.password = _integration.value;
                        }
                        if (_integration.key == "newcon_login_mail") {
                            self.form.newcon.login_mail = _integration.value;
                        }
                        if (_integration.key == "newcon_password_mail") {
                            self.form.newcon.password_mail = _integration.value;
                        }
                        if (_integration.key == "newcon_code_store") {
                            self.form.newcon.code_store = _integration.value;
                        }
                        if (_integration.key == 'newcon_administrator') {
                            self.form.newcon.administrator_id = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_retroactive_months') {
                            self.form.newcon.retroactive_months = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_is_logging') {
                            self.form.newcon.is_logging = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_update_value') {
                            self.form.newcon.update_value = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_installment_type') {
                            self.form.newcon.installment_type = _integration.value
                        }
                        if (_integration.key == 'newcon_auto_pay_installments') {
                            self.form.newcon.auto_pay_installments = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_installment_faturada') {
                            self.form.newcon.installment_faturada = parseInt(_integration.value)
                        }
                        if (_integration.key == "newcon_unifisa_is_active") {
                            self.form.newcon_unifisa.is_active = _integration.value == '1';
                        }
                        if (_integration.key == "newcon_unifisa_login") {
                            self.form.newcon_unifisa.login = _integration.value;
                        }
                        if (_integration.key == "newcon_unifisa_password") {
                            self.form.newcon_unifisa.password = _integration.value;
                        }
                        if (_integration.key == "newcon_unifisa_code_store") {
                            self.form.newcon_unifisa.code_store = _integration.value;
                        }
                        if (_integration.key == 'newcon_unifisa_administrator') {
                            self.form.newcon_unifisa.administrator_id = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_unifisa_retroactive_months') {
                            self.form.newcon_unifisa.retroactive_months = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_unifisa_is_logging') {
                            self.form.newcon_unifisa.is_logging = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_unifisa_update_value') {
                            self.form.newcon_unifisa.update_value = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_unifisa_installment_type') {
                            self.form.newcon_unifisa.installment_type = _integration.value
                        }
                        if (_integration.key == 'newcon_unifisa_comissionado') {
                            self.form.newcon_unifisa.comissionado = _integration.value
                        }
                        if (_integration.key == 'newcon_unifisa_auto_pay_installments') {
                            self.form.newcon_unifisa.auto_pay_installments = parseInt(_integration.value)
                        }
                        if (_integration.key == 'newcon_unifisa_installment_faturada') {
                            self.form.newcon_unifisa.installment_faturada = parseInt(_integration.value)
                        }
                    });

                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                });
            },
            onSubmit(_ev) {
                var self = this;
                var formDisal = self.form.disal;
                var validDisal = self.validation.disal;
                var formNewcon = self.form.newcon
                var validNewcon = self.validation.newcon;
                var formNewconUnifisa = self.form.newcon_unifisa
                var validNewconUnifisa = self.validation.newcon_unifisa;
                var valid = true;

                validDisal.login = '';
                validDisal.password = '';
                validDisal.administrators = '';
                validDisal.retroactive_months = '';

                if (formDisal.is_active == 1) {
                    if (formDisal.login == '') {
                        validDisal.login = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formDisal.password == '') {
                        validDisal.password = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formDisal.code_store == '') {
                        validDisal.code_store = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formDisal.retroactive_months == '') {
                        validDisal.retroactive_months = 'Campo obrigatório!';
                        valid = false;
                    }
                }

                validNewcon.login = '';
                validNewcon.password = '';
                validNewcon.login_mail = '';
                validNewcon.password_mail = '';
                validNewcon.administrators = '';
                validNewcon.retroactive_months = '';

                if (formNewcon.is_active == 1) {
                    if (formNewcon.login == '') {
                        validNewcon.login = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewcon.password == '') {
                        validNewcon.password = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewcon.login_mail == '') {
                        validNewcon.login_mail = 'Campo obrigatório!';
                        valid = false;
                    } else if (!validation.mail(formNewcon.login_mail)) {
                        validNewcon.login_mail = "E-mail inválido!";
                        valid = false;
                    }

                    if (formNewcon.password_mail == '') {
                        validNewcon.password_mail = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewcon.code_store == '') {
                        validNewcon.code_store = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewcon.retroactive_months == '') {
                        validNewcon.retroactive_months = 'Campo obrigatório!';
                        valid = false;
                    }
                }

                validNewconUnifisa.login = '';
                validNewconUnifisa.password = '';
                validNewconUnifisa.administrators = '';
                validNewconUnifisa.retroactive_months = '';
                validNewconUnifisa.comissionado = '';

                if (formNewconUnifisa.is_active == 1) {
                    if (formNewconUnifisa.login == '') {
                        validNewconUnifisa.login = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewconUnifisa.password == '') {
                        validNewconUnifisa.password = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewconUnifisa.code_store == '') {
                        validNewconUnifisa.code_store = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewconUnifisa.retroactive_months == '') {
                        validNewconUnifisa.retroactive_months = 'Campo obrigatório!';
                        valid = false;
                    }

                    if (formNewconUnifisa.comissionado == '') {
                        validNewconUnifisa.comissionado = 'Campo obrigatório!';
                        valid = false;
                    }
                }

                if (valid) {
                    var formSender = {
                        'disal_is_active': formDisal.is_active ? '1' : '0',
                        'disal_login': formDisal.login,
                        'disal_password': formDisal.password,
                        'disal_administrator': formDisal.administrator_id,
                        'disal_code_store': formDisal.code_store,
                        'disal_retroactive_months': formDisal.retroactive_months,
                        'disal_is_logging': formDisal.is_logging ? '1' : '0',
                        'newcon_is_active': formNewcon.is_active ? '1' : '0',
                        'newcon_login': formNewcon.login,
                        'newcon_password': formNewcon.password,
                        'newcon_login_mail': formNewcon.login_mail,
                        'newcon_password_mail': formNewcon.password_mail,
                        'newcon_administrator': formNewcon.administrator_id,
                        'newcon_code_store': formNewcon.code_store,
                        'newcon_retroactive_months': formNewcon.retroactive_months,
                        'newcon_is_logging': formNewcon.is_logging ? '1' : '0',
                        'newcon_update_value': formNewcon.update_value ? '1' : '0',
                        'newcon_installment_type': formNewcon.installment_type,
                        'newcon_auto_pay_installments': formNewcon.auto_pay_installments ? '1' : '0',
                        'newcon_installment_faturada': formNewcon.installment_faturada,
                        'newcon_unifisa_is_active': formNewconUnifisa.is_active ? '1' : '0',
                        'newcon_unifisa_login': formNewconUnifisa.login,
                        'newcon_unifisa_password': formNewconUnifisa.password,
                        'newcon_unifisa_administrator': formNewconUnifisa.administrator_id,
                        'newcon_unifisa_code_store': formNewconUnifisa.code_store,
                        'newcon_unifisa_retroactive_months': formNewconUnifisa.retroactive_months,
                        'newcon_unifisa_is_logging': formNewconUnifisa.is_logging ? '1' : '0',
                        'newcon_unifisa_update_value': formNewconUnifisa.update_value ? '1' : '0',
                        'newcon_unifisa_installment_type': formNewconUnifisa.installment_type,
                        'newcon_unifisa_comissionado': formNewconUnifisa.comissionado,
                        'newcon_unifisa_auto_pay_installments': formNewconUnifisa.auto_pay_installments ? '1' : '0',
                        'newcon_unifisa_installment_faturada': formNewconUnifisa.installment_faturada,
                    }

                    const response = self.$store.dispatch('integrations/add', formSender);

                    self.$root.$emit('onLoading');

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Integração cadastrada com sucesso!");
                        self.$router.push({'name': 'integrations.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }

                            if (err.data.errors.logo !== undefined) {
                                self.validation.logo = err.data.errors.logo[0];
                            }
                        }
                    });

                    console.log(formSender);
                }

                _ev.preventDefault();
            }
        }
    };
</script>